precision highp float;

uniform vec3 uColor;

varying float vDistToCamera;

void main() {
    vec2 uv = gl_PointCoord.xy;
    vec2 center = vec2(0.5);
    float distToCenter = distance(uv, center);
    float circle = 1.0 - smoothstep(0.03, 0.04, distToCenter);
    float maxDist = length(center);
    circle += (1.0 - distToCenter / maxDist) * 0.01;

    float opacity = smoothstep(9., 14., vDistToCamera);

    gl_FragColor = vec4(uColor, circle * (1.0 - opacity));
}